import { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { REQUEST_STATUS } from 'src/common/constants'
import { ConfirmAlert } from 'src/component/confirmAlert'
import ImgField from 'src/component/ImgField'
import PopupContainer from 'src/component/popup/PopupContainer'
import TextArea from 'src/component/TextArea'
import { Context } from 'src/context'
import { AddRequestAttachment, ReturnMedicine } from 'src/requests/Requests'
import { successToaster, ToBase64 } from 'src/utils'


interface INotesFileRequest {
    modalID: any
    recordID: string
}

const modalName = "popup-container"

const NotesFileRequest: FC<INotesFileRequest> = ({ modalID, recordID }) => {

    const [itemsData, setItemsData] = useState({ note: "", file: [] })

    const { t } = useTranslation()

    const { setLoading } = useContext(Context)

    const onChange = (key: string, value: string | File) =>
        setItemsData((prev: any) => ({ ...prev, [key]: value }))

    const handleSubmit = () => {

        ConfirmAlert(`${t('req-return')}`,
            () => {
                setLoading((l: number) => l + 1)

                ReturnMedicine(recordID, itemsData?.note).then(res => {
                    successToaster("operation-success")
                    handlefileData()
                }).finally(() => setLoading((l: number) => l - 1))
                handleReset()
            }, () => { })

    }

    const handlefileData = async () => {
        let stringifiedData = await handleConvertFilesToString()
        const dataForm = {
            requestId: recordID,
            targetStatusId: JSON.stringify(REQUEST_STATUS.return),
            attachments: stringifiedData
        }
        //@ts-ignore
        setLoading((l: number) => l + 1)
        AddRequestAttachment(dataForm).finally(() => setLoading((l: number) => l - 1))
    }

    const handleConvertFilesToString = async () => {
        if (!itemsData?.file.length) return []
        const filesData = await Promise.all(
            itemsData.file.map(async (file: File) => {
                const base64 = await ToBase64(file)
                return base64
            })
        )
        return filesData
    }



    const handleReset = () => {
        setItemsData({ note: "", file: [] })
    }

    return (
        <PopupContainer resetAllFields={handleReset} onApply={handleSubmit} modalID={modalID} Name='return-request' modalName={modalName}>
            <TextArea label='note' value={itemsData["note"]} setValue={(value: string) => onChange("note", value)} />
            <ImgField isMulti={true} ImgLink='' recordID={Math.random()} Img={itemsData["file"]} setImg={(value: File) => onChange("file", value)} label={"return-files"} placeHolderName={"return-files"} />
        </PopupContainer>

    )
}

export default NotesFileRequest